import { Injectable } from '@angular/core';

@Injectable()
export class ManageBreadcrumbService {

  isBreadcrumbShown = true;

  constructor() { }
}
